<template>
	<div>
		<AppHeader title="하이모 소식" is-history></AppHeader>
		<AppContent>
			<PromotionDetail></PromotionDetail>
		</AppContent>
		<AppFooter></AppFooter>
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppContent from '@/components/common/AppContent';
import AppFooter from '@/components/common/AppFooter';

import PromotionDetail from '@/components/PromotionDetail';

export default {
	components: {
		AppHeader,
		AppContent,
		AppFooter,
		PromotionDetail,
	},
};
</script>
